/**
 * TaskForm — das Aufgabenfenster.
 *
 * Ein einziges Fenster für Aufgaben, egal von wo es geöffnet wird: Hauptnavigation
 * (useAufgabenFenster), Aufgabenseite, Adressen, Projekte, Kontakthistorie, Leads, Chat, Termine.
 * Der Inhalt ist AufgabenDetail (Strato-Stil: Ansicht mit Feldraster und Unteraufgaben-Baum,
 * Bearbeiten direkt im Fenster statt in einem zweiten Modal).
 *
 * Die Props sind unverändert, damit alle bisherigen Aufrufer weiter funktionieren.
 * Unteraufgaben-Neuanlage: Prop parentTask oder (Altbestand) window.__subtask_parent.
 */
import { useEffect, useState } from 'react';
import DraggableResizableWindow from '../ui/DraggableResizableWindow';
import AufgabenDetail from './AufgabenDetail';

export function TaskForm({
  isOpen, onClose, task = null, onSuccess, preselectedAddressId = null, preselectedProjectId = null,
  initialStatus = 'open', defaultTitle = '', defaultDescription = '', parentTask = null,
}) {
  // Im Fenster kann zu Unter- und Hauptaufgaben gewechselt werden
  const [aktiveId, setAktiveId] = useState(task?.id || null);
  const [eltern, setEltern] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    setAktiveId(task?.id || null);
    setEltern(parentTask || window.__subtask_parent || null);
  }, [isOpen, task?.id, parentTask]);

  if (!isOpen) return null;

  const schliessen = () => {
    window.__subtask_parent = null;
    onClose?.();
  };

  const titel = aktiveId ? 'Aufgabe' : (eltern ? 'Neue Unteraufgabe' : 'Neue Aufgabe');

  return (
    <DraggableResizableWindow
      open={isOpen}
      onClose={schliessen}
      title={titel}
      testid="task-form-window"
      storageKey="Aufgabenfenster"
      initialWidth={820}
      initialHeight={760}
    >
      <AufgabenDetail
        key={aktiveId || 'neu'}
        taskId={aktiveId}
        task={aktiveId && task?.id === aktiveId ? task : null}
        preselectedAddressId={preselectedAddressId}
        preselectedProjectId={preselectedProjectId}
        initialStatus={initialStatus}
        defaultTitle={defaultTitle}
        defaultDescription={defaultDescription}
        parentTask={aktiveId ? null : eltern}
        onAufgabeOeffnen={(t) => setAktiveId(t.id)}
        onGespeichert={(gespeichert, { neu }) => {
          onSuccess?.(gespeichert);
          if (neu) {
            window.__subtask_parent = null;
            // Neue Aufgabe direkt in der Ansicht zeigen (dort lassen sich Unteraufgaben anlegen)
            if (gespeichert?.id) { setEltern(null); setAktiveId(gespeichert.id); } else schliessen();
          }
        }}
        onGeloescht={() => { onSuccess?.(); schliessen(); }}
        onSchliessen={schliessen}
      />
    </DraggableResizableWindow>
  );
}

export default TaskForm;
